import React from "react";
import { Modal, Button, Tooltip } from "antd";
import noop from "lodash/noop";

const styles = {
  btn: {
    minWidth: "108px",
    height: "32px",
  },
  btnPrimary: {
    minWidth: "108px",
    height: "32px",
    marginLeft: "8px",
  },
};

const ModalWindow = ({
  handleSubmit,
  handleCancel,
  handleReset = noop,
  submitButtonLoading = false,
  visible,
  title = "",
  children,
  cancelTextButton = "Отмена",
  submitTextButton = "Ок",
  submitButtonDisabled = false,
  width = 520,
  className = "",
  disabled,
  footerHide = false,
  submitTooltip = "",
  footer = !footerHide
    ? [
        // eslint-disable-next-line react/jsx-indent
        <Button style={styles.btn} key="back" onClick={handleReset}>
          {cancelTextButton}
        </Button>,
        // eslint-disable-next-line react/jsx-indent
        <Tooltip key="tooltip" title={submitTooltip}>
          <Button
            key="submit"
            type="primary"
            onClick={handleSubmit}
            disabled={disabled}
            style={styles.btnPrimary}
            loading={submitButtonLoading}
          >
            {submitTextButton}
          </Button>
        </Tooltip>,
      ]
    : "",
  centered = false,
}) => (
  <Modal
    title={title}
    visible={visible}
    onCancel={handleCancel}
    footer={footer}
    width={width}
    className={className}
    centered={centered}
  >
    {children}
  </Modal>
);

export default ModalWindow;
